var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.107,
    height: 13.132,
    viewBox: "0 0 16.107 13.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hands-helping",
    "data-name": "Icon awesome-hands-helping",
    d: "M12.281,4.926H8.455V6.362a1.812,1.812,0,1,1-3.624,0V3.243l-1.633,1a1.645,1.645,0,0,0-.783,1.406V6.863L.4,8.048A.828.828,0,0,0,.107,9.169l2.013,3.555a.8.8,0,0,0,1.1.3l2.6-1.531H9.261a1.628,1.628,0,0,0,1.611-1.642h.4a.812.812,0,0,0,.805-.821V7.389h.2a.608.608,0,0,0,.6-.616V5.542A.608.608,0,0,0,12.281,4.926ZM16,3.967,13.984.411a.8.8,0,0,0-1.1-.3l-2.6,1.531H7.71a1.6,1.6,0,0,0-.853.249l-.843.536a.819.819,0,0,0-.378.7v3.24a1.007,1.007,0,1,0,2.013,0V4.105h4.631A1.424,1.424,0,0,1,13.69,5.542v.731L15.7,5.088A.83.83,0,0,0,16,3.967Z",
    transform: "translate(0.002 -0.002)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.7786b750f551d3d0b0aa822ba86e0e02.svg";
export { ForwardRef as ReactComponent };